import React from 'react';

import loadable from "@loadable/component";
// import Header from './Header';
// import Footer from './Footer';

const Header = loadable(() => import('./Header'));
const Footer = loadable(() => import('./Footer'));


const Layout = ({ children }) => {
    return (
    <React.Fragment>
        <div className="ParentLayout">
          <Header />
          <div className="ChildLayout" style={{minHeight: `700px`}}>
              {children}
          </div>
          <Footer/>
        </div>
    </React.Fragment>
    );
};
export default Layout;